<img src="assets/layout/logo_white.png" [routerLink]="['/login']" alt="Logo" />
